import React from "react";
import {
  ActionList,
  ActionGroup,
  Action,
} from "./../../mood-ui/DataTable";

const TenantListActions = ({
  onClearSelection,
  onDelete,
  onActivationPush = () => {},
}) => (
  <ActionList onClearSelection={onClearSelection}>
    <ActionGroup>
      <Action label="Activation Push" onClick={onActivationPush} />
      <Action label="Delete" onClick={onDelete} />
    </ActionGroup>
  </ActionList>
);

export default TenantListActions;
